import * as React from 'react';
import { Origin, EditorType } from '../manage-installed-apps-page';
import { DeleteModal } from './delete-modal/delete-modal';
import { CheckAppStatusModal } from './check-app-status-modal/check-app-status-modal';
import { ReviewAppModal } from '@wix/app-market-collection-widget';
import { SupportModal } from './support-modal/support-modal';
import { UpdateModal } from './update-modal/update-modal';
import NewAppSettingsModal from './app-settings-modal/new-app-settings-modal';
import { ModuleRegistry } from 'react-module-container';
export var ModalNames;
(function (ModalNames) {
    ModalNames["NONE"] = "none";
    ModalNames["DELETE"] = "delete";
    ModalNames["IN_CONTEXT_INSTALLATION"] = "inContextInstallation";
    ModalNames["APP_STATUS"] = "checkAppStatus";
    ModalNames["APP_SETTINGS"] = "appSettings";
    ModalNames["RATE_APP"] = "rateApp";
    ModalNames["SUPPORT"] = "support";
    ModalNames["EDIT_REVIEW"] = "editReview";
    ModalNames["UPDATE"] = "update";
})(ModalNames || (ModalNames = {}));
export function Modals({ openModalName, closeModal, app, baseUrl, authorizationHeader, origin, editorUrl, checkStatusUrl, settingsUrl, deleteApp, locale, msId, showUserActionNotification, editorType, openDeleteModalAppInEditor, }) {
    const shouldUseNewReviewAppModal = openModalName === ModalNames.RATE_APP ||
        openModalName === ModalNames.EDIT_REVIEW;
    const showSuccessToast = (message) => {
        if (showUserActionNotification) {
            showUserActionNotification({
                message,
                biName: 'review-app',
                type: 'SUCCESS',
            });
        }
    };
    return (React.createElement(React.Fragment, null,
        openModalName === ModalNames.DELETE && (React.createElement(DeleteModal, { app: app, msId: msId, origin: origin, editorUrl: editorUrl, deleteApp: deleteApp, closeModal: closeModal, editorType: editorType, baseUrl: baseUrl, authorizationHeader: authorizationHeader, openDeleteModalAppInEditor: openDeleteModalAppInEditor })),
        openModalName === ModalNames.APP_STATUS && (React.createElement(CheckAppStatusModal, { checkStatusUrl: checkStatusUrl, closeModal: closeModal })),
        openModalName === ModalNames.APP_SETTINGS && (React.createElement(NewAppSettingsModal, { settingsUrl: settingsUrl, closeModal: closeModal })),
        shouldUseNewReviewAppModal && (React.createElement(ReviewAppModal, { locale: locale, appDefId: app.appId, isOpen: true, closeFn: closeModal, showSuccessToast: showSuccessToast, additionalBiData: {
                msid: msId,
                tagType: 'manage_apps',
                platform: origin === Origin.BIZMGR
                    ? editorType === EditorType.ADI
                        ? 'adi_dashboard'
                        : 'dashboard'
                    : origin,
            } })),
        openModalName === ModalNames.SUPPORT && (React.createElement(SupportModal, { app: app, msId: msId, origin: origin, closeModal: closeModal, showUserActionNotification: showUserActionNotification, authorizationHeader: authorizationHeader, baseUrl: baseUrl, editorType: editorType }))));
}
export function ModalsNew({ openModalName, closeModal, app, baseUrl, authorizationHeader, origin, editorUrl, checkStatusUrl, settingsUrl, deleteApp, locale, msId, showUserActionNotification, editorType, openDeleteModalAppInEditor, openCompleteUpdateInEditor, }) {
    const InContextInstallationModal = ModuleRegistry.component('in-context-installation-modal');
    const shouldUseNewReviewAppModal = openModalName === ModalNames.RATE_APP ||
        openModalName === ModalNames.EDIT_REVIEW;
    const showSuccessToast = (message) => {
        if (showUserActionNotification) {
            showUserActionNotification({
                message,
                biName: 'review-app',
                type: 'SUCCESS',
            });
        }
    };
    return (React.createElement(React.Fragment, null,
        openModalName === ModalNames.UPDATE && (React.createElement(UpdateModal, { app: app, msId: msId, closeModal: closeModal, openCompleteUpdateInEditor: openCompleteUpdateInEditor })),
        openModalName === ModalNames.DELETE && (React.createElement(DeleteModal, { app: app, msId: msId, origin: origin, editorUrl: editorUrl, deleteApp: deleteApp, closeModal: closeModal, editorType: editorType, baseUrl: baseUrl, authorizationHeader: authorizationHeader, openDeleteModalAppInEditor: openDeleteModalAppInEditor })),
        openModalName === ModalNames.IN_CONTEXT_INSTALLATION && (React.createElement(InContextInstallationModal, { appId: app?.appId, isOpen: true, intent: "dayful-flow", onInstallationSuccess: closeModal, onInstallationCancel: closeModal })),
        openModalName === ModalNames.APP_STATUS && (React.createElement(CheckAppStatusModal, { checkStatusUrl: checkStatusUrl, closeModal: closeModal })),
        openModalName === ModalNames.APP_SETTINGS && (React.createElement(NewAppSettingsModal, { settingsUrl: settingsUrl, closeModal: closeModal })),
        shouldUseNewReviewAppModal && (React.createElement(ReviewAppModal, { locale: locale, appDefId: app?.appId, isOpen: true, closeFn: closeModal, showSuccessToast: showSuccessToast, additionalBiData: {
                msid: msId,
                tagType: 'manage_apps',
                platform: origin === Origin.BIZMGR
                    ? editorType === EditorType.ADI
                        ? 'adi_dashboard'
                        : 'dashboard'
                    : origin,
            } })),
        openModalName === ModalNames.SUPPORT && (React.createElement(SupportModal, { app: app, msId: msId, origin: origin, closeModal: closeModal, showUserActionNotification: showUserActionNotification, authorizationHeader: authorizationHeader, baseUrl: baseUrl, editorType: editorType }))));
}
//# sourceMappingURL=modals.js.map